import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { LicensePrePaidSubFormDataProviderFactory } from '../factory/LicensePrePaidSubFormDataProviderFactory';
import { LicensePrePaidSubFormBaseDataProvider } from '../dataProvider/LicensePrePaidSubFormBaseDataProvider';
import { PrePaidLicenseInformation } from '../../types/PrePaidLicenseInformation';

export class LicensePrePaidSubFormRepository extends BaseWebComponentRepository {
  public dataProviderFactory: LicensePrePaidSubFormDataProviderFactory;
  public dataProvider: LicensePrePaidSubFormBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new LicensePrePaidSubFormDataProviderFactory(),
    });
  }

  public async getLicenseKeyInfo(
    licenseKeyFieldValue: string,
    companyId: string | null,
    returnIncompatibleProducts: boolean
  ): Promise<PrePaidLicenseInformation> {
    const response = await this.dataProvider.getLicenseKeyInfo(
      licenseKeyFieldValue,
      companyId,
      returnIncompatibleProducts
    );

    // no license status received
    if (!response || !response.data || !response.data.status) {
      throw new Error('Pre-paid license information response is invalid');
    }

    return response;
  }

  public async getRootVisibilityTree(): Promise<string> {
    return this.dataProvider.getRootVisibilityTree();
  }
}
